export default "__VITE_ASSET__bad7597c__"